import React from 'react';
import propTypes from 'prop-types';

import BadgeThin from './BadgeThin';

const vintageBadgeStyle = {
  backgroundColor: 'red',
  color: 'white',
};

const isActiveVintageValue = value => (
  value === true ||
  value === 1 ||
  value === '1' ||
  value === 'true'
);

const VintageBadge = ({ className, show }) => {
  if (!isActiveVintageValue(show)) {
    return null;
  }

  return (
    <BadgeThin
      className={className}
      style={vintageBadgeStyle}
    >
      Vintage
    </BadgeThin>
  );
};

VintageBadge.defaultProps = {
  className: '',
  show: false,
};

VintageBadge.propTypes = {
  className: propTypes.string,
  show: propTypes.oneOfType([
    propTypes.bool,
    propTypes.number,
    propTypes.string,
  ]),
};

export default VintageBadge;
